enum ActionTypes {
    HIGHLIGHT_COMPONENT_PROPERTY_LAYERS = "barrel/highlightComponentPropertyLayers",
    RESET_HIGHLIGHTED_COMPONENT_PROPERTY_LAYERS = "barrel/resetHighlightedComponentPropertyLayers"
}

export default ActionTypes;
